module.exports = __webpack_public_path__ + "fonts/poppins-bold-webfont.b39febf3.woff2";